import { Link } from "@tanstack/react-router";
import { Menu, Phone, X } from "lucide-react";
import { useState } from "react";
import { SITE } from "@/lib/site";
import mlcLogo from "@/assets/mlc-logo.webp.asset.json";


const NAV = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/gallery", label: "Gallery" },
  { to: "/service-areas", label: "Service Areas" },
  { to: "/about", label: "About" },
  { to: "/resources", label: "Resources" },
  { to: "/blog", label: "Blog" },
  { to: "/faqs", label: "FAQs" },
  { to: "/contact", label: "Contact" },
];

export function Header() {
  const [open, setOpen] = useState(false);
  return (
    <>
    <header className="sticky top-0 z-50 border-b border-black/10 bg-white/95 backdrop-blur-md">
      <div className="container-x flex items-center justify-between gap-4 py-3">
        <Link to="/" className="flex items-center gap-2" aria-label={SITE.name}>
          <img src={mlcLogo.url} alt={`${SITE.name} logo`} width={200} height={84} className="h-12 md:h-14 w-auto" fetchPriority="high" decoding="async" />
        </Link>


        <nav className="hidden lg:flex items-center gap-7" aria-label="Primary">
          {NAV.slice(1, 7).map((n) => (
            <Link
              key={n.to}
              to={n.to}
              className="text-sm font-medium uppercase tracking-wider text-[#1F2730] hover:text-copper transition-colors"
              activeOptions={{ exact: n.to === "/" }}
              activeProps={{ className: "text-copper" }}
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={SITE.phoneHref}
            className="inline-flex items-center gap-2 text-sm font-semibold text-copper hover:text-copper-hover"
          >
            <Phone className="h-4 w-4 text-copper" /> {SITE.phone}
          </a>
          <Link
            to="/quote"
            className="inline-flex items-center justify-center rounded-sm bg-copper px-5 py-2.5 text-sm font-bold uppercase tracking-wider text-white hover:bg-copper-hover transition-colors"
          >
            Get Free Quote
          </Link>
        </div>

        <div className="lg:hidden flex items-center gap-3">
          <a
            href={SITE.phoneHref}
            aria-label={`Call ${SITE.phone}`}
            className="inline-flex items-center gap-2 text-sm font-semibold text-copper"
          >
            <Phone className="h-5 w-5 text-copper fill-current" />
            <span className="hidden md:inline">{SITE.phone}</span>
          </a>
          <button
            aria-label="Open menu"
            onClick={() => setOpen(true)}
            className="inline-flex h-11 w-11 items-center justify-center rounded-sm border border-black/15 text-charcoal"
          >
            <Menu className="h-5 w-5" />
          </button>
        </div>
      </div>

    </header>

      {open && (
        <div className="fixed inset-0 z-[60] bg-white lg:hidden overflow-y-auto" style={{ backgroundColor: "#ffffff" }}>
          <div className="container-x flex items-center justify-between py-4 border-b border-black/10">
            <span className="font-display text-lg font-extrabold tracking-tight text-brand-navy">MLC <span className="text-copper">EPOXY</span></span>
            <button
              aria-label="Close menu"
              onClick={() => setOpen(false)}
              className="inline-flex h-11 w-11 items-center justify-center rounded-sm border border-black/15 text-charcoal"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
          <nav className="container-x flex flex-col gap-1 pt-6" aria-label="Mobile">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className="border-b border-black/10 py-4 text-xl font-display uppercase tracking-wider text-[#1F2730]"
              >
                {n.label}
              </Link>
            ))}
          </nav>
          <div className="container-x mt-8 flex flex-col gap-3">
            <Link
              to="/quote"
              onClick={() => setOpen(false)}
              className="block rounded-sm bg-copper px-5 py-4 text-center text-base font-bold uppercase tracking-wider text-white"
            >
              Get Free Quote
            </Link>
            <a
              href={SITE.phoneHref}
              className="inline-flex items-center justify-center gap-2 rounded-sm border border-copper px-5 py-4 text-base font-semibold text-copper"
            >
              <Phone className="h-4 w-4" /> Call {SITE.phone}
            </a>
          </div>
        </div>
      )}
    </>
  );
}

